import { AppRoutePath } from 'Pages/routes';
import Link from 'next/link';

const ServiceProviderOutOfRangeAlert = () => {
  return (
    <div
      className="bg-primary p-4"
    >
      <div
        className="flex flex-col gap-4 items-center w-full "
      >
        <span className="text-white font-bold text-2xl">
          Sorry, this service provider doesn’t serve your area.
        </span>
        <div className="flex sm:flex-col md:flex-row gap-2">
          <span className="text-white font-bold text-2xl">
            Select a different location, or
          </span>
          <Link
            className="text-white font-bold text-2xl"
            href={AppRoutePath.BROWSE_SERVICE_TYPES}>
            <span className="text-white underline">
              browse other service providers
            </span>
          </Link>
          <span className="text-white font-bold text-2xl">
            in your area
          </span>
        </div>
      </div>
    </div>
  );
};

export default ServiceProviderOutOfRangeAlert;
